// extracted by mini-css-extract-plugin
export default {"btn":"changeEditingModeButton_btn__8yLN5","active":"changeEditingModeButton_active__-OUFP"};